var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.all_stocks()),function(st,ind){return _c('Stock',{key:st.id,class:[ind%2 == 0 ? 'left' : 'right'],attrs:{"stock":st}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }